import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-red.svg'
import _imports_1 from '@/assets/images/logo.svg'


const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = ["tabindex"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Zijbalk uitklappen"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["aria-hidden"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Logo gemeente Land van Cuijk",
  id: "logo"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Zijbalk inklappen"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

import { ref, Ref } from "vue";
import MapFilters from '@/components/MapFilters.vue'
import ViewportMarkers from '@/components/ViewportMarkers.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoHolder',
  setup(__props) {

const windowAcitive: Ref<boolean> = ref(true)
const toggleFilters = () => windowAcitive.value = !windowAcitive.value

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "info-window",
    class: _normalizeClass({ active: windowAcitive.value }),
    "aria-expanded": windowAcitive.value,
    role: "complementary",
    "aria-label": "Zijbalk met projectenoverzicht"
  }, [
    _createElementVNode("button", {
      id: "window-toggle-on",
      onClick: toggleFilters,
      tabindex: windowAcitive.value ? -1 : 0
    }, _hoisted_4, 8, _hoisted_2),
    _createElementVNode("div", {
      class: "window-container",
      "aria-hidden": !windowAcitive.value,
      style: _normalizeStyle({ visibility: windowAcitive.value ? 'visible' : 'hidden' })
    }, [
      _createElementVNode("div", { class: "window-header" }, [
        _hoisted_6,
        _createElementVNode("button", {
          onClick: toggleFilters,
          id: "window-toggle-off"
        }, _hoisted_8)
      ]),
      _createVNode(MapFilters),
      _createVNode(ViewportMarkers)
    ], 12, _hoisted_5)
  ], 10, _hoisted_1))
}
}

})